/**
 * A federated partner's secret values (Feature 48).
 *
 * The middle store of the `$secret` chain (organization → THIS → global),
 * holding one credential every organization the partner provisioned
 * shares. Encrypted server-side and never read back; the listing reports
 * only whether each defined field is set.
 */
import { apiDelete, apiGet, apiPut } from '../client.js';
import type { PartnerSecretEntry } from '../types.js';

export function listPartnerSecrets(
  partnerId: string,
): Promise<PartnerSecretEntry[]> {
  return apiGet<PartnerSecretEntry[]>(
    `/api/v1/admin/federated-partners/${partnerId}/secrets`,
  );
}

export function setPartnerSecret(
  partnerId: string,
  fieldKey: string,
  value: unknown,
): Promise<void> {
  return apiPut<void>(
    `/api/v1/admin/federated-partners/${partnerId}/secrets/${encodeURIComponent(fieldKey)}`,
    { value },
  );
}

export function deletePartnerSecret(
  partnerId: string,
  fieldKey: string,
): Promise<void> {
  return apiDelete<void>(
    `/api/v1/admin/federated-partners/${partnerId}/secrets/${encodeURIComponent(fieldKey)}`,
  );
}
